var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 88 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m73.561 28.062.083.679.663.169c3.606.917 6.82 3.066 9.123 6.11 2.305 3.047 3.564 6.812 3.57 10.696C87 55.284 79.518 63 70.4 63H22C10.457 63 1 53.23 1 41.143c0-9.513 6.78-18.407 15.827-21.217l.448-.139.18-.433C22.12 8.095 32.305 1 44 1c15.123 0 27.695 11.792 29.561 27.062ZM49.4 52.857V42.143h8.136c2.49 0 3.896-2.858 2.377-4.83l-13.536-17.58a3 3 0 0 0-4.754 0l-13.536 17.58c-1.519 1.972-.113 4.83 2.377 4.83H38.6v10.714a3 3 0 0 0 3 3h4.8a3 3 0 0 0 3-3Z",
    stroke: "#B0E9E9",
    strokeWidth: 2
  })));
};

export { SvgUpload as ReactComponent };
export default __webpack_public_path__ + "static/media/upload.253aa3ca.svg";